import React from 'react'
import injectSheet from 'react-jss'
import styles from './action.styles'
import actionMap from './action.map'

const Action = ({ classes, id, type }) => {
  const ActionByType = actionMap[type]

  return (
    (actionMap[type] && (
      <li className={classes.container}>
        <ActionByType key={id} id={id} />
      </li>
    )) ||
    null
  )
}

export default injectSheet(styles)(Action)
